// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Ifq2","notes":"Notes_notes__S2oi1","note":"Notes_note__1NIVN","markdown":"Notes_markdown__1euDf"};